import "./cotizador.css";
import { domain } from "../../Urls/Services/Api_urls";
import React, { useEffect, useState } from "react";
import { NavArrowLeft, NavArrowRight } from "iconoir-react";
import Slider from "react-slick";
import CardcompraInit from "./Cards/cardcompraInit";
import CardcomprasinInit from "./Cards/cardcomprasinInit";
import CardTVPlan from "./Cards/CardTVPlan";
import Subcarouselcomp from "../Bannersecundario/Subcarouselcomp";
import Footer from "../Footer/footer";
import Addhelp from "../Helpcomp/Addhelp";

const CotizadortestIni = ({
  funcion,
  ruta,
  nombreButton,
  displaycall,
  setLoading,
  Loader,
  Parametro,
}) => {

  const grupo = window.sessionStorage.getItem("groups");


  const [data, setData] = useState([]);
  const [send, setSend] = useState("Triple");
  const [renderBtn, setRenderBtn] = useState(false);
  const [btnState, setBtnstate] = useState(" active");
  const [btnState1, setBtnstate1] = useState("");
  const [btnState2, setBtnstate2] = useState("");
  const [btnState3, setBtnstate3] = useState("");
  const [showTvButtons, setShowTvButtons] = useState(true);
  const [selectedTvType, setSelectedTvType] = useState("PLATAPLUS");
  const [currentTipoplan, setCurrentTipoplan] = useState("Triple");
  const [Estratoprice, setEstratoprice] = useState(1);
  
  // Estados para controlar la visibilidad de botones según disponibilidad de planes
  const [hasTriplePlans, setHasTriplePlans] = useState(false);
  const [hasDoblePlans, setHasDoblePlans] = useState(false);
  const [hasDuplaPlans, setHasDuplaPlans] = useState(false);
  const [hasInternetPlans, setHasInternetPlans] = useState(false);
  
  // Estados para controlar la visibilidad de botones de TV
  const [hasTvBasico, setHasTvBasico] = useState(false);
  const [hasTvPlata, setHasTvPlata] = useState(false);
  const [hasTvPlataPlus, setHasTvPlataPlus] = useState(false);

  const normalizeTipoplan = (value = "") => String(value).trim().toLowerCase();
  
  // Configuración para planes regulares
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: data.length > 4 ? 4 : data.length,
    slidesToScroll: 1,
    initialSlide: 1,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1774,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 682,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  // Configuración específica para tarjetas de TV (carrusel horizontal)
  const tvSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: data.length > 4 ? 4 : data.length,
    slidesToScroll: 1,
    initialSlide: 1,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1774,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 682,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  const precioEstrato = () => {
    let Estrato = window.sessionStorage.getItem("estrato");
    if (Estrato != null) {
      setEstratoprice(parseInt(Estrato));
    } else {
      setEstratoprice(1);
    }
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#a3a3a3",
          borderRadius: "100px",
        }}
        onClick={onClick}
      >
        <NavArrowRight />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#a3a3a3",
          borderRadius: "100px",
        }}
        onClick={onClick}
      >
        <NavArrowLeft />
      </div>
    );
  }

  const onclicktriple = (e) => {
    if (btnState === "") {
      setSend("Triple");
      setCurrentTipoplan("Triple");
      setBtnstate(" active");
      setBtnstate1("");
      setBtnstate2("");
      setBtnstate3("");
      setShowTvButtons(true);
      setSelectedTvType("PLATAPLUS");
    }
  };

  const onclickDupla = (e) => {
    if (btnState1 === "") {
      setSend("Doble");
      setCurrentTipoplan("Doble");
      setBtnstate1(" active");
      setBtnstate("");
      setBtnstate2("");
      setBtnstate3("");
      setShowTvButtons(true);
      setSelectedTvType("PLATAPLUS");
    }
  };

  const onclickDuplaInt = (e) => {
    if (btnState2 === "") {
      setSend("Dupla");
      setCurrentTipoplan("Dupla");
      setBtnstate2(" active");
      setBtnstate("");
      setBtnstate1("");
      setBtnstate3("");
      setShowTvButtons(false);
    }
  };

  const onclickInt = (e) => {
    if (btnState3 === "") {
      setSend("Internet");
      setCurrentTipoplan("Internet");
      setBtnstate3(" active");
      setBtnstate("");
      setBtnstate1("");
      setBtnstate2("");
      setShowTvButtons(false);
    }
  };

  const onClickTvType = (type) => {
    setSelectedTvType(type);
  };

  const Descuentocard = (paquetes, index) => {
    const {
      tipoplan,
      nombre_plan,
      velocidad,
      json_valor,
      descuento,
      campaing,
      meses,
      megas,
      id__planes,
      descuento_valor,
      codigo_open,
      discount_months,
    } = paquetes;
    <li key="{data}"></li>;

    const estratoview = ["1-3", "4-6"];
    const estrato = estratoview[index % 2];

    if (campaing != null) {
      return (
        <CardcompraInit
          tipoplan={tipoplan}
          nombreplan={nombre_plan}
          velocidad={velocidad}
          precio_persona={json_valor.residencial}
          precio_empresa={json_valor.comercial}
          descuento={descuento}
          months={meses}
          discount_months={discount_months}
          descuento_valor={descuento_valor}
          codigo_open={codigo_open}
          id__planes={id__planes}
          megas={megas}
          estrato={Estratoprice}
          estratoview={estrato}
          color="#F9F3F3"
          font="303030"
          buttondis={""}
          ruta={ruta}
          funcion={funcion}
          display={displaycall}
          nombreButton={nombreButton}
          setLoading={setLoading}
          Loader={Loader}
        />
      );
    } else {
      return (
        <CardcomprasinInit
          nombreButton={nombreButton}
          ruta={ruta}
          funcion={funcion}
          display={displaycall}
          setLoading={setLoading}
          Loader={Loader}
          buttondis={""}
          estrato={Estratoprice}
          estratoview={estrato}
          tipoplan={tipoplan}
          nombreplan={nombre_plan}
          velocidad={velocidad}
          precio_persona={json_valor.residencial}
          precio_empresa={json_valor.comercial}
          codigo_open={codigo_open}
          id__planes={id__planes}
          color="#F9F3F3"
          font="303030"
        />
      );
    }
  };

  useEffect(() => {
    const getData = () => {
      fetch(
        domain +
          "/portal/plan/?state=" +
          (grupo === "vendedor_PAP" || grupo === "facilitador_comercial"
            ? 2
            : 1),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((data) => data.json())
        .then((data) => {
          setData(data);
          let datos = data;
          
          // Verificar disponibilidad de tipos de planes
          const hasTriple = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "triple"
          );
          const hasDoble = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "doble"
          );
          const hasDupla = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "dupla"
          );
          const hasInternet = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "internet"
          );
          
          setHasTriplePlans(hasTriple);
          setHasDoblePlans(hasDoble);
          setHasDuplaPlans(hasDupla);
          setHasInternetPlans(hasInternet);
          setRenderBtn(hasTriple);
          
          // Verificar disponibilidad de tipos de TV
          const hasBasico = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   planNameUpper.includes("BASICO") && !planNameUpper.includes("PLATA");
          });
          
          const hasPlata = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   planNameUpper.includes("PLATA") && 
                   !planNameUpper.includes("PLATAPLUS") &&
                   !planNameUpper.includes("PLATA PLUS");
          });
          
          const hasPlataPlus = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   (planNameUpper.includes("PLATAPLUS") || planNameUpper.includes("PLATA PLUS"));
          });
          
          setHasTvBasico(hasBasico);
          setHasTvPlata(hasPlata);
          setHasTvPlataPlus(hasPlataPlus);
          
          // Seleccionar automáticamente el primer tipo de plan disponible
          if (hasTriple) {
            setSend("Triple");
            setCurrentTipoplan("Triple");
            setBtnstate(" active");
            setBtnstate1(""); setBtnstate2(""); setBtnstate3("");
            setShowTvButtons(true); 
            if (hasPlataPlus) {
              setSelectedTvType("PLATAPLUS");
            } else if (hasPlata) {
              setSelectedTvType("PLATA");
            } else if (hasBasico) {
              setSelectedTvType("BASICO");
            }
          } else if (hasDoble) {
            setSend("Doble");
            setCurrentTipoplan("Doble");
            setBtnstate1(" active");
            setBtnstate(""); setBtnstate2(""); setBtnstate3("");
            setShowTvButtons(true);
            if (hasPlataPlus) {
              setSelectedTvType("PLATAPLUS");
            } else if (hasPlata) {
              setSelectedTvType("PLATA");
            } else if (hasBasico) {
              setSelectedTvType("BASICO");
            }
          } else if (hasDupla) {
            setSend("Dupla");
            setCurrentTipoplan("Dupla");
            setBtnstate2(" active");
            setBtnstate(""); setBtnstate1(""); setBtnstate3("");
            setShowTvButtons(false);
          } else if (hasInternet) {
            setSend("Internet");
            setCurrentTipoplan("Internet");
            setBtnstate3(" active");
            setBtnstate(""); setBtnstate1(""); setBtnstate2("");
            setShowTvButtons(false);
          }
        });
    };

    getData();
    precioEstrato();
  }, []);

  return (
    <div className="cti overflow-x-hidden">
      <div style={{ height: 40 }} />
      <div className="row">
        <h3 className="Emcalititle">
          Paquetes <b>fibra óptica</b> Emcali con más <b>megas</b> que nunca.
        </h3>
        <hr className="underline" style={{ padding: "0", margin: "0" }}></hr>
        
        {/* Primera fila de botones - horizontal */}
        <div className="d-flex justify-content-center flex-wrap gap-3 my-2 pt-3">
          {hasTriplePlans && (
            <button
              className={`ini${btnState}`}
              name="Triple"
              value={"Triple"}
              onClick={onclicktriple}
              style={{ minWidth: '200px' }}
            >
              Internet + Televisión + Telefonía
            </button>
          )}
          
          {hasDoblePlans && (
            <button
              className={`ini${btnState1}`}
              name="Dupla"
              value={"Dupla"}
              onClick={onclickDupla}
              style={{ minWidth: '150px' }}
            >
              Internet + Televisión
            </button>
          )}
          
          {hasDuplaPlans && (
            <button
              className={`ini${btnState2}`}
              name="DuplaInt"
              value={"Dupla"}
              onClick={onclickDuplaInt}
              style={{ minWidth: '150px' }}
            >
              Internet + Telefonía
            </button>
          )}
          
          {hasInternetPlans && (
            <button
              className={`ini${btnState3}`}
              name="Internet"
              value={"Internet"}
              onClick={onclickInt}
              style={{ minWidth: '60px' }}
            >
              Internet
            </button>
          )}
        </div>

        {/* Segunda fila de botones - Tipos de TV */}
        {showTvButtons && (
          <div className="d-flex justify-content-center flex-wrap gap-3">
            {hasTvBasico && (
              <button
                className={`ini${selectedTvType === "BASICO" ? " active" : ""}`}
                onClick={() => onClickTvType("BASICO")}
                style={{ minWidth: '100px' }}
              >
                TV Básica
              </button>
            )}
            
            {hasTvPlata && (
              <button
                className={`ini${selectedTvType === "PLATA" ? " active" : ""}`}
                onClick={() => onClickTvType("PLATA")}
                style={{ minWidth: '100px' }}
              >
                TV Plata
              </button>
            )}
            
            {hasTvPlataPlus && (
              <button
                className={`ini${selectedTvType === "PLATAPLUS" ? " active" : ""}`}
                onClick={() => onClickTvType("PLATAPLUS")}
                style={{ minWidth: '100px' }}
              >
                TV Plata Plus
              </button>
            )}
          </div>
        )}
      </div>
      <div className="container">
      {showTvButtons ? (
        // Mostrar planes de TV con configuración específica de carrusel
        data.length > 0 ? (
            <Slider {...tvSettings} key={`tv-${currentTipoplan}-${selectedTvType}-${Estratoprice}`}>
              {data
                .filter((plan) => {
                  // Filtrar por tipo de plan (Triple o Doble con TV)
                  const isTipoplanMatch = 
                    (currentTipoplan === "Triple" && plan.tipoplan === "Triple") ||
                    (currentTipoplan === "Doble" && plan.tipoplan === "Doble");
                  
                  // Filtrar por tipo de TV basado en el nombre del plan
                  const planNameUpper = plan.nombre_plan.toUpperCase();
                  let isTvTypeMatch = false;
                  
                  if (selectedTvType === "BASICO") {
                    isTvTypeMatch = planNameUpper.includes("BASICO") && 
                                  !planNameUpper.includes("PLATA");
                  } else if (selectedTvType === "PLATA") {
                    isTvTypeMatch = planNameUpper.includes("PLATA") && 
                                  !planNameUpper.includes("PLATAPLUS") &&
                                  !planNameUpper.includes("PLATA PLUS");
                  } else if (selectedTvType === "PLATAPLUS") {
                    isTvTypeMatch = planNameUpper.includes("PLATAPLUS") || 
                                  planNameUpper.includes("PLATA PLUS");
                  }
                  
                  return isTipoplanMatch && isTvTypeMatch;
                })
                .flatMap((plan, planIndex) => {
                  // Crear dos versiones de cada plan: una para estrato 1-3 y otra para 4-6
                  const estratoRangos = [
                    { estrato: 1, estratoview: "1-3" },
                    { estrato: 4, estratoview: "4-6" }
                  ];

                  return estratoRangos.map((rango, rangoIndex) => {
                    // Obtener precio para el estrato correspondiente
                    const precio = plan.json_valor.residencial[rango.estrato.toString()] || 
                                  plan.json_valor.residencial["1"];
                    
                    // Obtener precio con descuento si existe campaña
                    const precioDescuento = plan.campaing && plan.descuento_valor 
                      ? (plan.descuento_valor[rango.estrato.toString()] || plan.descuento_valor["1"])
                      : null;

                    // Extraer el tipo de TV del nombre del plan
                    const planNameUpper = plan.nombre_plan.toUpperCase();
                    let tipoTv = "basico";
                    if (planNameUpper.includes("PLATAPLUS") || planNameUpper.includes("PLATA PLUS")) {
                      tipoTv = "plata plus";
                    } else if (planNameUpper.includes("PLATA")) {
                      tipoTv = "plata";
                    } else if (planNameUpper.includes("BASICO")) {
                      tipoTv = "basico";
                    }

                    return (
                      <div className="item" key={`${plan.nombre_plan}-${planIndex}-${rango.estratoview}`}>
                        <CardTVPlan
                          nombreplan={plan.nombre_plan}
                          velocidad={plan.velocidad}
                          tipoTv={tipoTv}
                          precio={precio}
                          precioDescuento={precioDescuento}
                          precio_persona={plan.json_valor?.residencial || {}}
                          precio_empresa={plan.json_valor?.comercial || {}}
                          descuento_valor={plan.descuento_valor || {}}
                          estrato={rango.estrato}
                          estratoview={rango.estratoview}
                          tipoplan={plan.tipoplan}
                          funcion={funcion}
                          nombreButton={nombreButton}
                          setLoading={setLoading}
                          Loader={Loader}
                          display={displaycall}
                          campaing={plan.campaing || false}
                          descuento={plan.descuento || null}
                          meses={plan.meses || null}
                          megas={plan.megas || 0}
                          discount_months={plan.discount_months || null}
                          name_campaing={plan.name_campaing || null}
                          fecha_inicio_descuento={plan.fecha_inicio_descuento || null}
                          fecha_fin_descuento={plan.fecha_fin_descuento || null}
                          id__planes={plan.id__planes || null}
                          codigo_open={plan.codigo_open || null}
                          ruta={ruta}
                          es_nuevo={plan.es_nuevo || false}
                        />
                      </div>
                    );
                  });
                })}
            </Slider>
        ) : (
          <div className="text-center py-5">
            <p>Cargando planes disponibles...</p>
          </div>
        )
      ) : (
        // Mostrar planes regulares (Internet) con configuración normal
        data.length > 0 ? (
          <Slider {...settings} key={`regular-${send}-${Estratoprice}`}>
            {data.map((data) => {
              return [0, 1].map((i) => {
                if (normalizeTipoplan(send) === normalizeTipoplan(data.tipoplan)) {
                  return <div className="item" key={`${data.tipoplan}-${data.id__planes}-${i}`}>{Descuentocard(data, i)}</div>;
                }
              });
            })}
          </Slider>
        ) : (
          <div className="text-center py-5">
            <p>Cargando...</p>
          </div>
        )
      )}
        <div style={{ height: 30 }} />
      </div>

      {/* Sección oculta normativa CRC v4 — todos los planes en el DOM al cargar la página */}
      <div style={{ display: "none" }} aria-hidden="true">
        {data.map((plan) =>
          [
            { estrato: 1, estratoview: "1-3", index: 0 },
            { estrato: 4, estratoview: "4-6", index: 1 },
          ].map((rango) => {
            if (plan.tipoplan === "Triple" || plan.tipoplan === "Doble") {
              const precio =
                plan.json_valor?.residencial?.[rango.estrato.toString()] ||
                plan.json_valor?.residencial?.["1"] || 0;
              const precioDescuento =
                plan.campaing && plan.descuento_valor
                  ? plan.descuento_valor[rango.estrato.toString()] || plan.descuento_valor["1"]
                  : null;
              const planNameUpper = plan.nombre_plan.toUpperCase();
              let tipoTv = "basico";
              if (planNameUpper.includes("PLATAPLUS") || planNameUpper.includes("PLATA PLUS")) {
                tipoTv = "plata plus";
              } else if (planNameUpper.includes("PLATA")) {
                tipoTv = "plata";
              }
              return (
                <CardTVPlan
                  key={`crc-tv-${plan.id__planes}-${rango.estratoview}`}
                  nombreplan={plan.nombre_plan}
                  velocidad={plan.velocidad}
                  tipoTv={tipoTv}
                  precio={precio}
                  precioDescuento={precioDescuento}
                  precio_persona={plan.json_valor?.residencial || {}}
                  estrato={rango.estrato}
                  estratoview={rango.estratoview}
                  tipoplan={plan.tipoplan}
                  funcion={funcion}
                  nombreButton={nombreButton}
                  campaing={plan.campaing || false}
                  descuento={plan.descuento || null}
                  meses={plan.meses || null}
                  megas={plan.megas || 0}
                  ruta={ruta}
                />
              );
            }
            const precioReg =
              plan.json_valor?.residencial?.[rango.estrato.toString()] ||
              plan.json_valor?.residencial?.["1"] || 0;
            const velTotal =
              plan.megas && parseInt(plan.megas) > 0
                ? parseInt(plan.megas) + parseInt(plan.velocidad)
                : plan.velocidad;
            return (
              <div
                key={`crc-reg-${plan.id__planes}-${rango.estratoview}`}
                className="plan pospago"
                dane="76001,76520,76892,76130,76364"
                operador="EMCALI"
                operador-nit="890399003"
                titulo={plan.nombre_plan}
                valor-numerico={parseInt(precioReg)}
                estrato={rango.estratoview === "1-3" ? "1,2,3" : "4,5,6"}
              >
                <div className="operador-logo">
                  https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png
                </div>
                <div className="url-comercial">
                  https://portalservicios.emcali.net.co/planes
                </div>
                <div className="internet" tecnologia="108">
                  <div>Internet de <span className="velocidad-bajada">{velTotal}</span> Mbps de bajada</div>
                  <div>Internet de <span className="velocidad-subida">{velTotal}</span> Mbps de subida</div>
                </div>
                {plan.tipoplan === "Dupla" && (
                  <div className="telefonia">
                    <span className="minutos-incluidos">ilimitados</span> minutos a destinos fijos locales
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default CotizadortestIni;